import { render, staticRenderFns } from "./VehiclePartSelector.vue?vue&type=template&id=010d9dc2&scoped=true"
import script from "./VehiclePartSelector.vue?vue&type=script&lang=js"
export * from "./VehiclePartSelector.vue?vue&type=script&lang=js"
import "./VehiclePartSelector.vue?vue&type=style&index=0&id=010d9dc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010d9dc2",
  null
  
)

export default component.exports